/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $InitialScan = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    s3: {
      properties: {
        url: {
          type: 'string',
          isRequired: true,
        },
        fields: {
          description: `Required fields to be apart of the upload`,
          properties: {},
          isRequired: true,
        },
      },
      isRequired: true,
    },
  },
} as const;
